import { parse, RootQueryNode } from '@jupiterone/query-language-parser';

const parseQuery = (query: string) => {
  return parse(query) as RootQueryNode | undefined;
};

export default parseQuery;
